<template>
  <div></div>
</template>
<script>
import { TYPE } from "@brackets/vue-toastification";
import { mapActions } from "vuex";

const INTERNAL_SERVER_ERROR =
  "Ein unerwarteter Fehler im Server ist aufgetreten. Bitte kontaktieren sie den Support.";
const GENERAL_CLIENT_ERROR =
  "Ein unerwarteter Fehler ist aufgetreten. Bitte kontaktieren sie den Support.";
const WARNING = "warning";
const ERROR = "error";

export default {
  methods: {
    ...mapActions(["logout"]),
    handleError(err) {
      if (err.response) {
        // client received an error response (5xx, 4xx)
        if (err.response.status === 401) {
          this.logout("expired");
        } else if (err.response.status === 404) {
          this.showMessage({
            message: "Die angeforderten Daten konnten nicht gefunden werden.",
            type: WARNING,
          });
        } else if (err.response.status < 500) {
          this.showMessage({
            message: err.response.data.message,
            type: err.response.data.type || WARNING,
          });
        } else {
          this.showMessage({
            message: INTERNAL_SERVER_ERROR,
            type: ERROR,
          });
        }
      } else if (err.request) {
        this.showMessage({
          message:
            "Es gibt Probleme mit der Verbindung zum System. Bitte versuchen Sie es später erneut",
          type: WARNING,
        });
      } else {
        this.showMessage({
          message: GENERAL_CLIENT_ERROR,
          type: ERROR,
        });
        // anything else
      }
    },
    showInfo(message) {
      this.showMessage({
        message: message,
        type: TYPE.INFO,
      });
    },
    showSuccess(message) {
      this.showMessage({
        message,
        type: TYPE.SUCCESS,
      });
    },
    showError(message) {
      this.showMessage({
        message,
        type: TYPE.ERROR,
      });
    },
    showMessage(message) {
      if (message != null) {
        let type = message.type ?? TYPE.INFO;
        if (message.type === "danger") type = TYPE.ERROR;
        if (message.type === "warning") type = TYPE.WARNING;
        this.$toast(message.message, {
          type: type,
        });
      }
    },
  },
};
</script>
